import { AuthGuardService } from '../services/auth-guard.service';

import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProfileSettingsComponent } from './profile.settings/profile.settings.component';


const ProfileRouting: Routes = [
    // login view
    {
        path: 'profile', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: ProfileSettingsComponent },
            { path: 'settingss', component: ProfileSettingsComponent },
            // handle all other routes
            { path: '**', component: ProfileSettingsComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(ProfileRouting)],
    exports: [RouterModule]
})
export class ProfileRoutingModule { }
